import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import Fab from '@mui/material/Fab';
import { Badge, Tooltip, styled } from '@mui/material';
import { GppGood } from '@mui/icons-material';
import { BrandContext } from '../../../contexts/BrandContext';
import { statusMap } from './StatusMap';
import { iconMap } from '../../../contexts/BookingUtilities';


export default function ProgressIconSmall(props) {
  
    let handleClick = () => {};
  
    const {
        taxiBooking:{
            taxiBookingJobs=[],
        },
        defaultIcon,
        onClick
    } = props;
    
    let statusId = 1;

    if(onClick){
        handleClick = () => {
            onClick();
        }
    }


    if(taxiBookingJobs.length > 0){
        for(let i=0; i<taxiBookingJobs.length; i+=1){
            if(taxiBookingJobs[i].isActive){
                const taxiBookingJob = taxiBookingJobs[i];
                ({
                    status:{
                        id:statusId
                    },
                } = taxiBookingJob);
                break;
            }
        }
    }
    
    const statusIconSetup = statusMap[statusId];

    const {
        icon,
        percent,
        backgroundColor,
        inMotion,
        tooltipText,
        iconComponent:IconComponent
    } = statusIconSetup;

    const buttonSx = {
        bgcolor: backgroundColor,
        '&:hover': {
            bgcolor: backgroundColor,
        },
    }


    const brandContext = useContext(BrandContext);
    const {textContent} = brandContext;
    const toolTip = textContent[tooltipText];
    

    const StyledBadge = styled(Badge)(({ theme }) => ({
        '& .MuiBadge-badge': {
          right: 6,
          top:6,
          border: `2px solid ${theme.palette.background.paper}`,
          padding: '0 0px',
          width:'14px',
          minWidth:'14px',
          height:'14px',
          backgroundColor
        },
      }));

      

  return (
    <>
            <Box sx={{paddingTop:'2px', display:'flex', width:'24px', height:'24px',  justifyContent:'center'}}>
            
                <Box sx={{ position: 'relative'}}>        
                    <StyledBadge sx={{
                        verticalAlign:'unset',   
                    }} badgeContent="" color="primary">
                    {iconMap.LocalTaxi}
                    </StyledBadge>
                </Box>
            </Box>

   
    </>
  );
  
}